













































































































































import AsuhanKebidananGawatDarurat from "@/services/AsuhanKebidananGawatDarurat";
import { appModule } from "@/store/modules/app";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AskebGadarInputModal from "@/components/AskepGadar/AskebGadarInputModal.vue";
import { userModule } from "@/store/modules/user";
import AsesmenGadarKeperawatanStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarKeperawatanStore";

interface AsuhanItem {
  id: number;
  diagnosis: {
    id: number;
    name: string;
  };
  intervensi: [
    {
      id: number;
      name: string;
    }
  ];
  creator: {
    id: number;
    nama: string;
  };
  examinedAt: any;
}

@Component({
  components: {
    AskebGadarInputModal
  }
})
export default class AsuhanKebidananGawatDaruratCard extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;

  loading = false;

  asuhanList = [];

  saving = false;
  showInputModal = false;

  editedItem = null;

  get asesmenGadarPerawat() {
    return AsesmenGadarKeperawatanStore.asesmen;
  }

  get renderedAsuhanList() {
    return this.asuhanList.slice().sort((a, b) => {
      return (
        new Date(a.examinedAt).getTime() - new Date(b.examinedAt).getTime()
      );
    });
  }

  mounted() {
    this.getByRegister();
  }

  renderUsiaHamilText(val) {
    if (val) {
      const hr = val % 7,
        mg = (val - hr) / 7;

      return `${mg} Mg ${hr} Hr`;
    }

    return "";
  }

  async getByRegister() {
    let list = [];

    this.loading = true;

    await AsuhanKebidananGawatDarurat.getByRegister(this.register).then(
      function(response) {
        list = response.data.map(item => {
          return {
            g: item.content.g,
            p: item.content.p,
            a: item.content.a,
            ah: item.content.ah,
            usiaHamil: item.content.usiaHamil,
            id: item.id,
            diagnosis: item.content.diagnosis,
            intervensi: item.content.intervensi || [],
            creator: item.content.bidan,
            examinedAt: item.content.examinedAt
          };
        });
      }
    );

    this.asuhanList = list;
    this.loading = false;
  }

  addAsuhan() {
    if (
      this.asesmenGadarPerawat &&
      this.asesmenGadarPerawat.content.riwayatObstetri
    ) {
      this.showInputModal = true;
    } else {
      appModule.sendErrorAlert(
        "Riwayat Obstetri di Asesmen Awal Gawat Darurat belum terisi. Silahkan isi Riwayat Obstetri terlebih dahulu."
      );
    }
  }

  edit(item: AsuhanItem) {
    const canModify = this.checkIsUserCanModifyRecord(
      item,
      `Tidak bisa mengubah/edit asuhan yang sudah ditulis oleh ${item.creator.nama}`
    );

    if (canModify) {
      this.editedItem = item;

      this.showInputModal = true;
    }
  }

  remove(item: AsuhanItem) {
    const canModify = this.checkIsUserCanModifyRecord(
      item,
      `Tidak bisa menghapus asuhan yang sudah ditulis oleh ${item.creator.nama}`
    );

    if (canModify) {
      const q = confirm("Hapus Asuhan Kebidanan ini?");

      if (q) {
        AsuhanKebidananGawatDarurat.destroy(item.id).then(() => {
          appModule.NoticeDelay("Berhasil Hapus Asuhan Kebidanan");

          this.getByRegister();
        });
      }
    }
  }

  checkIsUserCanModifyRecord(record: AsuhanItem, message: string): boolean {
    if (userModule.user.id != record.creator.id) {
      appModule.sendErrorAlert(message);

      return false;
    }

    return true;
  }

  print() {
    AsuhanKebidananGawatDarurat.print(this.register);
  }

  @Watch("showInputModal")
  changedShowInputModal(val) {
    if (!val) {
      this.editedItem = null;
    }
  }
}
